var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.89 4.99523C11.1181 6.11482 10.9555 7.27878 10.4293 8.293C9.90313 9.30722 9.04515 10.1104 7.99845 10.5686C6.95175 11.0268 5.77961 11.1123 4.67749 10.8109C3.57537 10.5095 2.6099 9.83934 1.94207 8.91223C1.27425 7.98512 0.944443 6.85708 1.00765 5.71624C1.07086 4.57539 1.52327 3.4907 2.28943 2.64304C3.05559 1.79539 4.08919 1.23601 5.21786 1.05819C6.34654 0.880367 7.50206 1.09486 8.49173 1.66588",
    stroke: "#364153",
    strokeWidth: 0.999053,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.49561 5.49473L5.99418 6.99331L10.9894 1.99805",
    stroke: "#364153",
    strokeWidth: 0.999053,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.9886,
    height: 11.9886,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon10);
export default __webpack_public_path__ + "static/media/icon10.212f5942c9e39af65b481795163fd72b.svg";
export { ForwardRef as ReactComponent };